<template>
  <div class="background">
    <div class="chart-container">
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>

      <div class="Hcp-main-header">
        <div class="main-header-left">
          <img src="../../assets/LOGO.png">
        </div>
        <div class="main-header-right">
          <p>{{$t('Device Settings Report')}}</p>
          <p style="font-size: 13px;">{{$t('Device Settings at')}} {{time}}</p>
        </div>
      </div>

      <!--
            <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isFr}">
              <tr>
                <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
                <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
              </tr>
              <tr>
                <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
                <td class="td2">{{$t('pdm')}}</td><td colspan="8" class="td3">{{pdmSN}}</td>
              </tr>
              <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{tranSN}}</td></tr>
              <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{pumpSN}}</td></tr>
              <tr>
                <td class="td1 td4">{{$t('disType')}}</td><td colspan="9" class="td4">{{statics.medical_history}}</td>
              </tr>
            </table>


                  <div class="small-hr"></div>

                  <div class="statics middle-table">
                    <p class="custom" style="float: left">{{$t('calib')}}</p>
                    <table class="statics-table">
                      <tr>
                        <td class="td1">{{$t('Calibration Reminder')}}</td><td class="td1">{{cgm.sensor_alarm_settings.calib_remind_option}}</td>
                        <td class="td2">{{cgm.sensor_alarm_settings.calib_remind_time}}</td>
                      </tr>
                      <tr>
                        <td class="td1">{{$t('Calibration Repeat')}}</td><td class="td1">{{cgm.sensor_alarm_settings.calib_remind_interval}}</td><td></td>
                      </tr>
                      <tr>
                        <td class="td3">{{$t('Graph Range')}}</td><td class="td3">{{cgm.sensor_alarm_settings.trend_time_scope}}H</td><td></td>
                      </tr>
                    </table>
                  </div>
                  -->
    </div>

    <div class="background2">
      <div class="chart-container2">

      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  /*
   A4 尺寸： 210 mm x 297mm
   显示出来的是背景图片。
  * */
  export default{
    data() {
      return {
        time:'',rid:0, uid:0,st:0,et:0,data:{},unit:'',isMg:"",unit1:'',colock:'',isFr:false,
        statics:{},devices:['--','--','--'],hb1c:['--'],pdmSN:'',tranSN:'',pumpSN:'',maxBolOption:'',
        basal:{
          "basal_onoff": "--",
          "basal_select": "--",
          "max_rate":'--',
          "exer_basal": {
            "day_total": '--',
            "seg": []
          }
        },
        page4:true,
        moreBasal:true,
        basalPagePos:-9,
        basalPagePos2:-9,
        basalEndPage:{show:false, },
        cgmStartPage:{show:true, },

        basalSeg:[], bsg1:[],bsg2:[], bsg3:[],bsg4:[], total:0,
        standardTotal:0, exerTotal:0, holidayTotal:0, programATotal:0, programBTotal:0,

        standardSeg:[], standardSeg1:[],standardSeg2:[], standardSeg3:[],standardSeg4:[],
        exerSeg:[], exerSeg1:[],exerSeg2:[], exerSeg3:[],exerSeg4:[],
        holidaySeg:[], holidaySeg1:[],holidaySeg2:[], holidaySeg3:[],holidaySeg4:[],
        programASeg:[], programASeg1:[],programASeg2:[], programASeg3:[],programASeg4:[],
        programBSeg:[], programBSeg1:[],programBSeg2:[], programBSeg3:[],programBSeg4:[],

        // fm018新增3种基础量。
        sickSeg:[], sickSeg1:[], sickSeg2:[], sickSeg3:[],sickSeg4:[],
        programCSeg:[], programCSeg1:[],programCSeg2:[], programCSeg3:[],programCSeg4:[],
        programDSeg:[], programDSeg1:[],programDSeg2:[], programDSeg3:[],programDSeg4:[],


        basalInfo:[{}, {}, {}, {}, {}, {}, {}, {}],

        bolus:{
          "bg_reminder": "--",
          "bg_target": [],
          "bolus_reminder": [],
          "bolus_step": '--',
          "bolus_wizard": "--",
          "extent_option": "--",
          "ins_active_time": '--',
          "ins_carb_ratio": [],
          "ins_sen": [],
          "max_bolus": '--'
        },
        IcRatio:[],ins_sen:[],bg_target:[],bolus_rem:[],cgmLimit:[],
        cgm:{
          "alarm_silent_option": "--",
          "sensor_alarm_option": "--",
          "sensor_alarm_repeat": {
            "high": [
              "--",
              "--"
            ],
            "low": [
              "--",
              "--"
            ]
          },
          "sensor_alarm_settings": {
            "auto_calib_option": "--",
            "calib_remind_interval": "--",
            "calib_remind_option": "--",
            "calib_remind_time": "--",
            "no_calib_display": "--",
            "sensor_lost_time": '--',
            "trend_time_scope": '--'
          },
          "sensor_alarm_threshold": [],
          "sensor_forecast_alarm": {
            "high": [
              "--",
              "--"
            ],
            "low": [
              "--",
              "--"
            ]
          },
          "sensor_rate_alarm": {
            "fall": [
              "--",
              '--'
            ],
            "rise": [
              "--",
              '--'
            ]
          }
        },
        userset:{
          "alarm_type": "--",
          "auto_off_option": "--",
          "auto_off_time": "--",
          "backlight_timeout":"--",
          "beep_off_tip_interval": "--",
          "beep_off_tip_option":"--",
          "cgms_module_flag": "--",
          "clock": [],
          "clock_option": "--",
          "cmd_response": "--",
          "day_bolus_max": "--",
          "device_option": "--",
          "glucose_unit": "--",
          "hour_bolus_max": "--",
          "keypad_lock": "--",
          "low_reservoir_ins": "--",
          "low_reservoir_time": "--",
          "low_reservoir_type": "--",
          "password_option": "--",
          "patch_expire_ahead": "--",
          "patch_expire_alarm": "--",
          "pre_suspend_on_lowbg_level": "--",
          "pre_suspend_on_lowbg_option": "--",
          "pump_module_flag":"--",
          "screen_timeout": "--",
          "suspend_on_lowbg_level": "--",
          "suspend_on_lowbg_option": "--",
          "time_style": "--",
        },
        isEn:false,isDe:false,
      }
    },
    methods:{
      getStatics(){
        this.et= new Date(2017,9,19).getTime()/1000;
        this.st = this.et;
        let param = {
          st:this.st,
          et:this.et,
          tz:parseInt(sessionStorage.getItem('tz')),
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };
        param = B64.base64encode(JSON.stringify(param));
        this.$http.get('api/v2.1/report/'+this.uid+'/data/dse',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('Device Settings Report');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de'||lang==='it')?true:false;
      this.isFr =(lang==='fr')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      let ins_unit2=this.$t('ins_unit2')
      this.unit = (this.isMg)?' (mg/dL/'+ins_unit2+')':' (mmol/L/'+ins_unit2+')';
      this.unit1 = (this.isMg)?'mg/dL':'mmol/L';
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.time = sessionStorage.getItem('time6').split(',')[0];
      let img1 = document.getElementById('img6_1');
      img1.src = sessionStorage.getItem('src6_1');

      let img2 = document.getElementById('img6_2');
      img2.src = sessionStorage.getItem('src6_2');

      let img3 = document.getElementById('img6_3');
      img3.src = sessionStorage.getItem('src6_3');

      let img4 = document.getElementById('img6_4');
      img4.src = sessionStorage.getItem('src6_4');

      let img5 = document.getElementById('img6_5');
      img5.src = sessionStorage.getItem('src6_5');

      this.getStatics();
      this.data = JSON.parse(sessionStorage.getItem('deviceSet'));
      console.log('device setting:', this.data);

      if (true) {  // 编写测试数据
        //this.data.device_type=8;

        function padInt(v, n){
          let v_str=v.toString();
          let pre_num=n-v_str.length;
          let pre_str='';
          for (let i=0; i<pre_num;i++) {
            pre_str += '0';
          }
          return pre_str+v_str;
        }
        function minute_format(m){
          let hour=padInt(Math.floor(m/60), 2);
          let minute=padInt(m%60, 2);
          return hour+':'+minute;
        }

        let testSegs=[];
        for (let i=0; i<48; i++) {
          let minute=i*30;
          testSegs.push([minute_format(minute), parseFloat(((i%20)*0.1).toFixed(2)) ]);
        }
        //

        //console.log('testSegs:', testSegs);
        //this.data.settings.
        this.data.basal_settings.stand_basal.seg=testSegs;
        this.data.basal_settings.exer_basal.seg=testSegs;
        this.data.basal_settings.holiday_basal.seg=testSegs;
        this.data.basal_settings.program_a_basal.seg=testSegs;
        this.data.basal_settings.program_b_basal.seg=testSegs;
        this.data.basal_settings.program_c_basal.seg=testSegs;
        this.data.basal_settings.program_d_basal.seg=testSegs;
        this.data.basal_settings.sick_basal.seg=testSegs;

        //
        console.log('device setting test:', this.data);
      }

      if (18==this.data.device_type) {
        this.moreBasal=true;
      } else {
        this.moreBasal=false;
      }

      // 计算分页的地方
      if (true) {
        if (this.moreBasal) {
          let totalRow=0;
          //let basalPagePos=0;
          let pageTotalRow=0;
          let basalKey=["stand_basal", "exer_basal", "holiday_basal", "program_a_basal",
            "program_b_basal","program_c_basal","program_d_basal","sick_basal"];
          for (let i=0; i<8; i++) {
            let basal_pattern=this.data.basal_settings[basalKey[i]];
            totalRow += Math.floor((basal_pattern.seg.length+11)/12);
            if (totalRow>=12 && this.basalPagePos<0) {
              this.basalPagePos=i;
              //break;
              pageTotalRow=totalRow;
            }
            if (totalRow>=(12+16) && this.basalPagePos2<0) {
              this.basalPagePos2=i;
              //break;
              pageTotalRow=totalRow;
            }
          }
          console.log("basalTotalRow:", totalRow, pageTotalRow, this.basalPagePos, this.basalPagePos2);
        }
      }

      if (this.moreBasal){
        let img6 = document.getElementById('img6_6');
        img6.src = sessionStorage.getItem('src6_6');
        let img7 = document.getElementById('img6_7');
        img7.src = sessionStorage.getItem('src6_7');
        let img8 = document.getElementById('img6_8');
        img8.src = sessionStorage.getItem('src6_8');
      }

      this.basal = this.data.basal_settings;
      //if(this.basal.basal_select==='Exercise'){
        this.basalSeg = this.basal.exer_basal.seg;
        this.total = this.basal.exer_basal.day_total.toFixed(2);
        this.exerTotal=this.total;
        this.exerSeg=this.basalSeg;
        this.basalInfo[1].total=this.total;
        this.basalInfo[1].title='Exercise';

      //}
      //if(this.basal.basal_select==='Standard'){
        this.basalSeg = this.basal.stand_basal.seg;
        this.total = this.basal.stand_basal.day_total.toFixed(2);
        this.standardTotal=this.total;
        this.standardSeg=this.basalSeg;
        this.basalInfo[0].total=this.total;
      this.basalInfo[0].title='Standard';
      //}
      //if(this.basal.basal_select==='Holiday'){
        this.basalSeg = this.basal.holiday_basal.seg;
        this.total = this.basal.holiday_basal.day_total.toFixed(2);
        this.holidayTotal=this.total;
        this.holidaySeg=this.basalSeg;
      this.basalInfo[2].total=this.total;
      this.basalInfo[2].title='Holiday';
      //}
      //if(this.basal.basal_select==='ProgramA'){
        this.basalSeg = this.basal.program_a_basal.seg;
        this.total = this.basal.program_a_basal.day_total.toFixed(2);
        this.programATotal=this.total;
        this.programASeg=this.basalSeg;
      this.basalInfo[3].total=this.total;
      this.basalInfo[3].title='Program A';
      //}
      //if(this.basal.basal_select==='ProgramB'){
        this.basalSeg  = this.basal.program_b_basal.seg;
        this.total = this.basal.program_b_basal.day_total.toFixed(2);
        this.programBTotal=this.total;
        this.programBSeg=this.basalSeg;
      this.basalInfo[4].total=this.total;
      this.basalInfo[4].title='Program B';

      if (this.moreBasal) {
        //this.programCTotal=this.basal.program_c_basal.day_total.toFixed(2);
        this.programCSeg=this.basal.program_c_basal.seg;
        this.basalInfo[5].total=this.basal.program_c_basal.day_total.toFixed(2);
        this.basalInfo[5].title='Program C';

        this.programDSeg=this.basal.program_d_basal.seg;
        this.basalInfo[6].total=this.basal.program_d_basal.day_total.toFixed(2);
        this.basalInfo[6].title='Program D';

        this.sickSeg=this.basal.sick_basal.seg;
        this.basalInfo[7].total=this.basal.sick_basal.day_total.toFixed(2);
        this.basalInfo[7].title='Sick';
      } else {
        this.basalInfo.splice(5,3);
      }

      //}
      for(let i =0;i<this.basalSeg.length;i++){
          if(i<12){
            this.bsg1.push(this.basalSeg[i])
          }
          else if(i<24){
            this.bsg2.push(this.basalSeg[i])
          }
          else if(i<36){
            this.bsg3.push(this.basalSeg[i])
          }
          else{
            this.bsg4.push(this.basalSeg[i])
          }
      }

      console.log(this.basalInfo);

      var segName= ['standardSeg', 'exerSeg', 'holidaySeg', 'programASeg', 'programBSeg',
                    'programCSeg', 'programDSeg', 'sickSeg'];
      if (!this.moreBasal) {
        segName.splice(5,3);
      }
      for (let n=0; n<segName.length; n++) {
        this.basalInfo[n].bsg1=[];
        this.basalInfo[n].bsg2=[];
        this.basalInfo[n].bsg3=[];
        this.basalInfo[n].bsg4=[];

        this.basalInfo[n].bsg2show=false;
        this.basalInfo[n].bsg3show=false;
        this.basalInfo[n].bsg4show=false;
      }

      for (let n=0; n<segName.length; n++) {
        let curSeg=this[segName[n]];
        for(let i =0;i<curSeg.length;i++){
          if(i<12){
            this[segName[n]+'1'].push(curSeg[i])
            this.basalInfo[n].bsg1.push(curSeg[i]);
          }
          else if(i<24){
            this[segName[n]+'2'].push(curSeg[i])
            this.basalInfo[n].bsg2.push(curSeg[i]);
            this.basalInfo[n].bsg2show=true;
          }
          else if(i<36){
            this[segName[n]+'3'].push(curSeg[i])
            this.basalInfo[n].bsg3.push(curSeg[i]);
            this.basalInfo[n].bsg3show=true;
          }
          else{
            this[segName[n]+'4'].push(curSeg[i])
            this.basalInfo[n].bsg4.push(curSeg[i]);
            this.basalInfo[n].bsg4show=true;
          }
        }
      }
      console.log(this.basalInfo);
      // 处理基础量分页
      if (true) {
        let basalPageId='basalPage'+this.basalPagePos;
      }

      this.bolus = this.data.bolus_settings;
      this.IcRatio = this.data.bolus_settings.ins_carb_ratio;
      this.ins_sen = this.data.bolus_settings.ins_sen;
      this.bg_target = this.data.bolus_settings.bg_target;
      this.bolus_rem = this.data.bolus_settings.bolus_reminder;

      this.userset = this.data.user_settings;
      this.userset.sensor_sn = (this.userset.sensor_sn)?this.userset.sensor_sn:'--';
      this.userset.user_name = (this.userset.user_name)?this.userset.user_name:'--';
      this.userset.sensor_expire_option = (this.userset.sensor_expire_option)?this.$t(this.userset.sensor_expire_option):'--';
      this.userset.pump_sn = (this.userset.pump_sn)?this.userset.pump_sn:'--';
      this.userset.alarm_type = (this.userset.alarm_type)?this.$t(this.userset.alarm_type):'--';
      this.userset.low_reservoir_time = (this.userset.low_reservoir_type==='time')?this.userset.low_reservoir_time:this.$t(this.userset.low_reservoir_type)+' '+this.userset.low_reservoir_ins+ins_unit2;
      let opt = this.userset.patch_expire_alarm;
      this.userset.patch_expire_alarm = (opt==='On')?this.$t(opt)+' '+this.userset.patch_expire_ahead+'H':this.$t(opt);
      this.userset.auto_off_option = (this.userset.auto_off_option==='On')?this.$t(this.userset.auto_off_option)+' '+this.userset.auto_off_time+'H':this.$t(this.userset.auto_off_option);
      this.userset.pre_suspend_on_lowbg_option = (this.userset.pre_suspend_on_lowbg_option==='On')?this.$t(this.userset.pre_suspend_on_lowbg_option)+' '+this.userset.pre_suspend_on_lowbg_level:this.$t(this.userset.pre_suspend_on_lowbg_option);
      if(this.userset.clock){
        let that =this;
        this.userset.clock.map(function (e,i) {
          e[1] = that.$t(e[1]);
        })
      }

      this.userset.suspend_on_lowbg_option =this.$t( this.userset.suspend_on_lowbg_option);
      if( this.userset.suspend_on_lowbg_option===this.$t('On')){
        this.userset.suspend_on_lowbg_level =(this.isMg)?parseInt(this.userset.suspend_on_lowbg_level):this.userset.suspend_on_lowbg_level.toFixed(1);
        this.userset.suspend_on_lowbg_option =this.userset.suspend_on_lowbg_option+' '+this.userset.suspend_on_lowbg_level+this.unit1;
      }
      let option = this.$t(this.data.bolus_settings.bolus_reminder_option);
      this.maxBolOption = ' ('+option+ ')';

      this.pdmSN = sessionStorage.getItem('pdmSN');
      this.pumpSN = (this.userset.pump_sn)?this.userset.pump_sn:'--';
      this.tranSN =(this.userset.sensor_sn)?this.userset.sensor_sn:'--';
      function HexSNProc(deviceSN, decimalRange) {
        //let tranSN=deviceSN;

        if ('--'!=deviceSN){
          let tranSN=parseInt(deviceSN);
          console.log('tranSN.1:', tranSN);
          if (!isNaN(tranSN)){
            var inRange=false;
            for (var i=0; i<decimalRange.length; i++){
              if (decimalRange[i][0]<=tranSN && tranSN <= decimalRange[i][0]) {
                inRange=true;
                break;
              }
            }
            if (inRange) {
              return deviceSN;
            } else {
              function addPreZero(pdm_sn_hex, num){
                let pre='';
                for (let i=0; i<num; i++){
                  pre += '0';
                }
                return pre+pdm_sn_hex;
              }
              //console.log(sensor_serial.toString(16).toUpperCase())

              tranSN=tranSN.toString(16).toUpperCase();
              return addPreZero(tranSN, 8-tranSN.length);
            }
          }
        } else {
          return deviceSN;
        }
      }
      console.log('tranSN:', this.tranSN);
      this.tranSN=HexSNProc(this.tranSN, [[102000000, 103999999]]);
      this.pumpSN=HexSNProc(this.pumpSN, [[106000000, 106999999], [108000000, 108999999]]);

      this.userset.clock.map(function (e,i) {
        let time = auth.getTime2(e[0]);
        e[0] = time[0]+":"+time[1];
        return e;
      });

      this.cgm = this.data.sensor_settings;
      if(this.cgm.sensor_rate_alarm){
        this.cgm.sensor_rate_alarm.fall[1] = (this.cgm.sensor_rate_alarm.fall[0]!=="Off")?this.cgm.sensor_rate_alarm.fall[1].toFixed(3):'--';
        this.cgm.sensor_rate_alarm.rise[1] = (this.cgm.sensor_rate_alarm.rise[0]!=="Off")?this.cgm.sensor_rate_alarm.rise[1].toFixed(3):'--';
      }
      if(this.cgm.sensor_alarm_repeat){
        this.cgm.sensor_alarm_repeat.high[1] = (this.cgm.sensor_alarm_repeat.high[0]!=="Off")? this.cgm.sensor_alarm_repeat.high[1]:'--';
        this.cgm.sensor_alarm_repeat.low[1] = (this.cgm.sensor_alarm_repeat.low[0]!=="Off")? this.cgm.sensor_alarm_repeat.low[1]:'--';
      }
      if(this.cgm.sensor_forecast_alarm){
        this.cgm.sensor_forecast_alarm.high[1] = (this.cgm.sensor_forecast_alarm.high[0]!=="Off")? this.cgm.sensor_forecast_alarm.high[1]:'--';
        this.cgm.sensor_forecast_alarm.low[1] = (this.cgm.sensor_forecast_alarm.low[0]!=="Off")? this.cgm.sensor_forecast_alarm.low[1]:'--';
      }
      this.cgm.sensor_alarm_settings.calib_remind_time = (this.cgm.sensor_alarm_settings.calib_remind_option!=='Off')?this.cgm.sensor_alarm_settings.calib_remind_time:"--";
      this.cgm.sensor_alarm_settings.calib_remind_interval = (this.cgm.sensor_alarm_settings.auto_calib_option!=='Off')?this.cgm.sensor_alarm_settings.calib_remind_interval:"--";

      this.cgmLimit = this.cgm.sensor_alarm_threshold;

      this.basal.basal_select = this.$t(this.basal.basal_select);
      this.basal.basal_onoff = this.$t(this.basal.basal_onoff);
      this.bolus.bg_reminder = this.$t(this.bolus.bg_reminder);
      this.bolus.extent_option = this.$t(this.bolus.extent_option);
      this.bolus.bolus_wizard = this.$t(this.bolus.bolus_wizard);
      this.userset.cgms_module_flag = this.$t(this.userset.cgms_module_flag);
      this.userset.cmd_response = this.$t(this.userset.cmd_response);
      this.userset.clock_option = this.$t(this.userset.clock_option);
      this.userset.pump_module_flag = this.$t(this.userset.pump_module_flag);

      this.cgm.sensor_rate_alarm.fall[0] =this.$t(this.cgm.sensor_rate_alarm.fall[0]);
      this.cgm.sensor_rate_alarm.rise[0] =this.$t(this.cgm.sensor_rate_alarm.rise[0]);
      this.cgm.sensor_alarm_repeat.high[0] =this.$t(this.cgm.sensor_alarm_repeat.high[0]);
      this.cgm.sensor_alarm_repeat.low[0] =this.$t(this.cgm.sensor_alarm_repeat.low[0]);
      this.cgm.sensor_forecast_alarm.high[0] =this.$t(this.cgm.sensor_forecast_alarm.high[0]);
      this.cgm.sensor_forecast_alarm.low[0] =this.$t(this.cgm.sensor_forecast_alarm.low[0]);
      this.cgm.sensor_alarm_settings.calib_remind_option = this.$t(this.cgm.sensor_alarm_settings.calib_remind_option);
      this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
      this.cgm.alarm_silent_option = this.$t(this.cgm.alarm_silent_option);

      //setTimeout(auth._printPdf(),2000);
    },
  }
</script>

<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 20mm;
    width: 100%;
    height: 40mm;
    background: #ccc;
  }

  .background2{
    padding-top: 5mm;
    width: 100%;
    height: 40mm;
    background: #cc8;
  }

  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    height:40mm;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .chart-container2{
    width:400px;
    height:100px;
    margin:0 auto;
    background: #369;
    padding-top:0px;
  }

  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:13px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
    font-size:12px;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }

  .statics{
    margin-top: 15px;
    margin-bottom: 17px;
  }
  .statics p{
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.27px;
    text-align:left;
    padding-left: 3px;
    border-left: 2px solid #009fdf;;
  }
  .statics .custom{
    border:none;
    padding-left: 5px;
    float: left;
  }
  .statics-table{
    width: 94%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    font-size: 13px;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:20px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .spe-text{
    float: right;
    min-width: 140px;
    margin-right: 25px;
  }
  .spe-text p{
    border:none;
    float: right;

  }
  .small-table{
    width: 30.6%;
    float: left;
    margin-left: 2%;
    margin-top: -5px;
  }
  .middle-table{
    width: 50%;
    float: left;
    margin-left: 1%;
    margin-top: -5px;
  }

  .context{
    width: 93%;
    margin:0 auto;
  }
  .context p{
    font-family:SFUIText-Regular;
    font-size:10px;
    color:#282828;
    letter-spacing:-0.24px;
    text-align:left;
    margin-left: 2px;
  }
  .chart-container .graph{
    width:103%;
    height: 135px;
    margin-left: -2.5%;
    margin-top: 10px;
  }

  .page-seperator2 {
    margin-top:20mm;
  }

  .page-seperator3 {
    margin-top:30mm;
  }

  .page-seperator4 {
    margin-top:40mm;
  }

  .page-seperator5 {
    margin-top:50mm;
  }

  .page4{
    height:297mm;
  }

</style>



// WEBPACK FOOTER //
// chart6_print2.vue?3b9f6e6a